// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import { onMounted } from 'vue'
import hybridPage from '@/lib/hybridPage'
import { GaGeneralPageName } from '@/assets/ts/customEvent'
import { setCurrentGaPageName } from '@/lib/utils'
import ShipmentProtectionShopping from '@/pages/shipment-protection-shopping/components/_ShipmentProtectionShopping.vue'
import type { TabbedFlowSectionContent } from '@/components/TabbedFlowSteps.vue'
import type { ExcludedCoverageContent } from '@/components/ExcludedCoverageSection.vue'

hybridPage()

export interface PageContent {
	banner: {
		title: string
		description: string
		toggle: {
			shipping: string
			shopping: string
		}
	}
	comparison: {
		title: string
		subtitle: string
		description?: string
		plans: {
			buyShipPlus: ComparisonPlan
			basic: ComparisonPlan
		}
		categories: ComparisonCategory[]
		disclaimer: {
			lines: string[]
			legal?: {
				jurisdiction: string
				termsUrl?: string
			}
		}
		settings: {
			showTooltips: boolean
			highlightRecommended: boolean
		}
	}
	flowContent: TabbedFlowSectionContent
	FAQ: {
		sectionTitle: string
		questions: string
		CTAButton: {
			text: string
			link: string
		}
		faqItems: {
			id: string
			title: string
			description: string
			answer: {
				steps: string[]
				note?: string
			}
		}[]
		linkCards: {
			title: string
			description: string
			href: string
		}[]
	}
	excludedCoverage: ExcludedCoverageContent
}

export interface ComparisonPlan {
	id: string
	name: string
	price: string
	recommended: boolean
	features?: string[]
	badge?: {
		text: string
		variant: 'primary' | 'secondary' | 'success'
	}
}

export interface ComparisonFeature {
	id: string
	label: string
	buyShipPlus: string | boolean
	basic: string | boolean
	hasTooltip?: boolean
	tooltipContent?: string
	category?: string
	priority?: 'high' | 'medium' | 'low'
	note?: string
}

export interface ComparisonCategory {
	id: string
	name: string
	description?: string
	hasInfo?: boolean
	infoContent?: string
	features: ComparisonFeature[]
	bgColor?: string
}

createApp({
	name: 'Shipment Protection Shopping',
	components: {
		ShipmentProtectionShopping,
	},
	setup() {
		const { pageContent } = window

		onMounted(() => {
			setCurrentGaPageName(GaGeneralPageName.ShoppingProtection)
		})

		return {
			pageContent,
		}
	},
}).mount('#bsMain')
